import {DefaultUrlSerializer, UrlSegmentGroup, UrlTree} from '@angular/router';

// Source - https://stackoverflow.com/a
// Posted by ankhansen
// Retrieved 2025-11-24, License - CC BY-SA 4.0

export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    const urlTree = super.parse(url);

    this.lowerCaseSegments(urlTree.root);

    return urlTree;
  }

  private lowerCaseSegments(urlSegmentGroup: UrlSegmentGroup): void {
    if (urlSegmentGroup.hasChildren()) {
      Object.entries(urlSegmentGroup.children).forEach(
        ([key, value]) => this.lowerCaseSegments(value)
      );
    }

    urlSegmentGroup.segments.forEach((segment) => segment.path = segment.path.toLowerCase());
  }
}
